// src/pages/Register.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import api from "../services/api";
import "./Login.css";
import AccountHomeButton from "../pages/Auth/account-home-button";
import SuccessPopup from "./SuccessPopup";
import ErrorPopup from "./ErrorPopup";

const Register = () => {
  const navigate = useNavigate();

  const [form, setForm] = useState({
  first_name: "",
  last_name: "",
  email: "",
  phone: "",
  password: "",
  confirmPassword: "",
  smsConsent: false,
  legalConsent: false,
});

  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");

  const onChange = (e) => {
    const { name, type, checked, value } = e.target;
    setForm((f) => ({ ...f, [name]: type === "checkbox" ? checked : value }));
  };

  const validate = () => {
    const e = {};

    if (!form.first_name.trim()) e.first_name = "Please enter your first name";
    if (!form.last_name.trim()) e.last_name = "Please enter your last name";

    if (!form.email) e.email = "Please enter your email";
    else if (!/^\S+@\S+\.\S+$/.test(form.email)) e.email = "Invalid email";

    if (!form.phone.trim()) e.phone = "Please enter your phone number";

    if (!form.password) e.password = "Please enter your password";
    else if (form.password.length < 8) {
      e.password = "Password must be at least 8 characters";
    }

    if (!form.confirmPassword) {
      e.confirmPassword = "Please confirm your password";
    } else if (form.confirmPassword !== form.password) {
      e.confirmPassword = "Passwords must match";
    }

    if (!form.smsConsent) {
      e.smsConsent = "You must agree to receive SMS for verification";
    }

    if (!form.legalConsent) {
      e.legalConsent = "You must agree to the Privacy Policy and Terms of Service";
    }

   

    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const showSuccess = (message) => {
    setPopupMessage(message);
    setShowErrorPopup(false);
    setShowSuccessPopup(true);
  };

  const showError = (message) => {
    setPopupMessage(message);
    setShowSuccessPopup(false);
    setShowErrorPopup(true);
  };

  const handleSuccessClose = () => {
    setShowSuccessPopup(false);
    navigate("/login");
  };

  const onSubmit = async (evt) => {
    evt.preventDefault();
    if (!validate()) return;

    setSubmitting(true);

    try {
      await api.post("/register", form);
      showSuccess("Registration successful!");
    } catch (err) {
      console.error("Registration failed:", err);
      showError(err?.response?.data?.message || "Registration failed.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <React.Fragment>
      <AccountHomeButton />

      <div className="log-page">
        <div className="log-left">
          <div className="log-left-inner">
            <h1 className="log-title">Registration</h1>

            

            <form className="log-form" onSubmit={onSubmit} noValidate>
              <input
                className={`log-input ${errors.first_name ? "log-input-error" : ""}`}
                id="first_name"
                name="first_name"
                type="text"
                placeholder="Enter first name"
                value={form.first_name}
                onChange={onChange}
                autoComplete="given-name"
              />
              {errors.first_name && <div className="log-error">{errors.first_name}</div>}

              <input
                className={`log-input ${errors.last_name ? "log-input-error" : ""}`}
                id="last_name"
                name="last_name"
                type="text"
                placeholder="Enter last name"
                value={form.last_name}
                onChange={onChange}
                autoComplete="family-name"
              />
              {errors.last_name && <div className="log-error">{errors.last_name}</div>}

              <input
                className={`log-input ${errors.email ? "log-input-error" : ""}`}
                id="email"
                name="email"
                type="email"
                placeholder="Enter Email Address"
                value={form.email}
                onChange={onChange}
                autoComplete="email"
              />
              {errors.email && <div className="log-error">{errors.email}</div>}

              <input
                className={`log-input ${errors.phone ? "log-input-error" : ""}`}
                id="phone"
                name="phone"
                type="tel"
                placeholder="Enter phone number"
                value={form.phone}
                onChange={onChange}
                autoComplete="tel"
              />
              {errors.phone && <div className="log-error">{errors.phone}</div>}

              <div className="log-password-wrap">
                <input
                  className={`log-input log-password-input ${
                    errors.password ? "log-input-error" : ""
                  }`}
                  id="password"
                  name="password"
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter password (min 8 characters)"
                  value={form.password}
                  onChange={onChange}
                  autoComplete="new-password"
                />
                <button
                  type="button"
                  className="log-eye"
                  onClick={() => setShowPassword((s) => !s)}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                  title={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
              {errors.password && <div className="log-error">{errors.password}</div>}

              <div className="log-password-wrap">
                <input
                  className={`log-input log-password-input ${
                    errors.confirmPassword ? "log-input-error" : ""
                  }`}
                  id="confirmPassword"
                  name="confirmPassword"
                  type={showConfirm ? "text" : "password"}
                  placeholder="Re-enter password"
                  value={form.confirmPassword}
                  onChange={onChange}
                  autoComplete="new-password"
                />
                <button
                  type="button"
                  className="log-eye"
                  onClick={() => setShowConfirm((s) => !s)}
                  aria-label={showConfirm ? "Hide confirm password" : "Show confirm password"}
                  title={showConfirm ? "Hide confirm password" : "Show confirm password"}
                >
                  {showConfirm ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
              {errors.confirmPassword && (
                <div className="log-error">{errors.confirmPassword}</div>
              )}

              <div className="log-row-between" style={{ marginTop: 10 }}>
                <label className="log-remember">
                  <input
                    type="checkbox"
                    name="smsConsent"
                    checked={form.smsConsent}
                    onChange={onChange}
                  />
                  <span>
                    By providing my phone number and checking this box, I consent to
                    receive SMS messages from PayWeek for account verification (OTP)
                    and security purposes. Message frequency varies based on activity.
                    Reply STOP to opt out or HELP for help. Message and data rates may
                    apply.
                  </span>
                </label>
              </div>
              {errors.smsConsent && <div className="log-error">{errors.smsConsent}</div>}

              <div className="log-row-between" style={{ marginTop: 10 }}>
                <label className="log-remember">
                  <input
                    type="checkbox"
                    name="legalConsent"
                    checked={form.legalConsent}
                    onChange={onChange}
                  />
                  <span>
                    I agree to PayWeek&apos;s{" "}
                    <button
                      type="button"
                      className="log-inline-link"
                      onClick={() => navigate("/privacy-policy")}
                    >
                      Privacy Policy
                    </button>{" "}
                    and{" "}
                    <button
                      type="button"
                      className="log-inline-link"
                      onClick={() => navigate("/terms")}
                    >
                      Terms of Service
                    </button>
                    .
                  </span>
                </label>
              </div>
              {errors.legalConsent && <div className="log-error">{errors.legalConsent}</div>}

              <button className="log-submit" type="submit" disabled={submitting}>
                {submitting ? "Creating account…" : "Create account"}
              </button>

              <button
                type="button"
                className="log-link-btn"
                onClick={() => navigate("/login")}
              >
                Already have an account? Sign in
              </button>
            </form>
          </div>
        </div>

        <div className="log-right">
          <div className="log-quote">
            <div className="log-quote-mark">“</div>
            <p>
              Focus on growing your business — PayWeek takes care of your payroll and
              accounting with speed, precision, and complete security, so you can pay
              your team effortlessly and on time, every time.
            </p>
          </div>

          <div
            className="log-dashboard-shell"
            role="img"
            aria-label="Dashboard screenshot placeholder"
          >
            <img src="/acc-page.png" alt="Dashboard (light)" className="logo--light" />
            <img src="/dashdark.png" alt="Dashboard (dark)" className="logo--dark" />
          </div>
        </div>
      </div>

      {showSuccessPopup && (
        <SuccessPopup
          title="Registration Successful"
          message={popupMessage}
          onClose={handleSuccessClose}
          buttonLabel="Go to Login"
        />
      )}

      {showErrorPopup && (
        <ErrorPopup
          title="Registration Failed"
          message={popupMessage}
          onClose={() => setShowErrorPopup(false)}
          buttonLabel="Close"
        />
      )}
    </React.Fragment>
  );
};

export default Register;




// // src/pages/Register.jsx
// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { FaEye, FaEyeSlash } from "react-icons/fa";
// import api from "../services/api";
// import "./Login.css";
// import AccountHomeButton from "../pages/Auth/account-home-button";
// import SuccessPopup from "./SuccessPopup";
// import ErrorPopup from "./ErrorPopup";

// const Register = () => {
//   const navigate = useNavigate();

//   const [form, setForm] = useState({
//     first_name: "",
//     last_name: "",
//     email: "",
//     phone: "",
//     password: "",
//     confirmPassword: "",
//     smsConsent: false,
//   });

//   const [errors, setErrors] = useState({});
//   const [submitting, setSubmitting] = useState(false);
//   const [showPassword, setShowPassword] = useState(false);
//   const [showConfirm, setShowConfirm] = useState(false);

//   const [showSuccessPopup, setShowSuccessPopup] = useState(false);
//   const [showErrorPopup, setShowErrorPopup] = useState(false);
//   const [popupMessage, setPopupMessage] = useState("");

//   const onChange = (e) => {
//     const { name, type, checked, value } = e.target;
//     setForm((f) => ({ ...f, [name]: type === "checkbox" ? checked : value }));
//   };

//   const validate = () => {
//     const e = {};

//     if (!form.first_name.trim()) e.first_name = "Please enter your first name";
//     if (!form.last_name.trim()) e.last_name = "Please enter your last name";
//     if (!form.email) e.email = "Please enter your email";
//     else if (!/^\S+@\S+\.\S+$/.test(form.email)) e.email = "Invalid email";

//     if (!form.phone.trim()) e.phone = "Please enter your phone number";

//     if (!form.password) e.password = "Please enter your password";
//     else if (form.password.length < 8) {
//       e.password = "Password must be at least 8 characters";
//     }

//     if (!form.confirmPassword) {
//       e.confirmPassword = "Please confirm your password";
//     } else if (form.confirmPassword !== form.password) {
//       e.confirmPassword = "Passwords must match";
//     }

//     if (!form.smsConsent) {
//       e.smsConsent = "You must agree to receive SMS for verification";
//     }

//     setErrors(e);
//     return Object.keys(e).length === 0;
//   };

//   const showSuccess = (message) => {
//     setPopupMessage(message);
//     setShowErrorPopup(false);
//     setShowSuccessPopup(true);
//   };

//   const showError = (message) => {
//     setPopupMessage(message);
//     setShowSuccessPopup(false);
//     setShowErrorPopup(true);
//   };

//   const handleSuccessClose = () => {
//     setShowSuccessPopup(false);
//     navigate("/login");
//   };

//   const onSubmit = async (evt) => {
//     evt.preventDefault();
//     if (!validate()) return;

//     setSubmitting(true);

//     try {
//       await api.post("/register", form);
//       showSuccess("Registration successful!");
//     } catch (err) {
//       console.error("Registration failed:", err);
//       showError(err?.response?.data?.message || "Registration failed.");
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   return (
//     <React.Fragment>
//       <AccountHomeButton />

//       <div className="log-page">
//         {/* LEFT SIDE */}
//         <div className="log-left">
//           <div className="log-left-inner">
//             <h1 className="log-title">Registration</h1>

//             <form className="log-form" onSubmit={onSubmit} noValidate>
//               <input
//                 className={`log-input ${errors.first_name ? "log-input-error" : ""}`}
//                 id="first_name"
//                 name="first_name"
//                 type="text"
//                 placeholder="Enter first name"
//                 value={form.first_name}
//                 onChange={onChange}
//                 autoComplete="given-name"
//               />
//               {errors.first_name && <div className="log-error">{errors.first_name}</div>}

//               <input
//                 className={`log-input ${errors.last_name ? "log-input-error" : ""}`}
//                 id="last_name"
//                 name="last_name"
//                 type="text"
//                 placeholder="Enter last name"
//                 value={form.last_name}
//                 onChange={onChange}
//                 autoComplete="family-name"
//               />
//               {errors.last_name && <div className="log-error">{errors.last_name}</div>}

//               <input
//                 className={`log-input ${errors.email ? "log-input-error" : ""}`}
//                 id="email"
//                 name="email"
//                 type="email"
//                 placeholder="Enter Email Address"
//                 value={form.email}
//                 onChange={onChange}
//                 autoComplete="email"
//               />
//               {errors.email && <div className="log-error">{errors.email}</div>}

//               <input
//                 className={`log-input ${errors.phone ? "log-input-error" : ""}`}
//                 id="phone"
//                 name="phone"
//                 type="tel"
//                 placeholder="Enter phone number"
//                 value={form.phone}
//                 onChange={onChange}
//                 autoComplete="tel"
//               />
//               {errors.phone && <div className="log-error">{errors.phone}</div>}

//               <div className="log-password-wrap">
//                 <input
//                   className={`log-input log-password-input ${
//                     errors.password ? "log-input-error" : ""
//                   }`}
//                   id="password"
//                   name="password"
//                   type={showPassword ? "text" : "password"}
//                   placeholder="Enter password (min 8 characters)"
//                   value={form.password}
//                   onChange={onChange}
//                   autoComplete="new-password"
//                 />
//                 <button
//                   type="button"
//                   className="log-eye"
//                   onClick={() => setShowPassword((s) => !s)}
//                   aria-label={showPassword ? "Hide password" : "Show password"}
//                   title={showPassword ? "Hide password" : "Show password"}
//                 >
//                   {showPassword ? <FaEyeSlash /> : <FaEye />}
//                 </button>
//               </div>
//               {errors.password && <div className="log-error">{errors.password}</div>}

//               <div className="log-password-wrap">
//                 <input
//                   className={`log-input log-password-input ${
//                     errors.confirmPassword ? "log-input-error" : ""
//                   }`}
//                   id="confirmPassword"
//                   name="confirmPassword"
//                   type={showConfirm ? "text" : "password"}
//                   placeholder="Re-enter password"
//                   value={form.confirmPassword}
//                   onChange={onChange}
//                   autoComplete="new-password"
//                 />
//                 <button
//                   type="button"
//                   className="log-eye"
//                   onClick={() => setShowConfirm((s) => !s)}
//                   aria-label={showConfirm ? "Hide confirm password" : "Show confirm password"}
//                   title={showConfirm ? "Hide confirm password" : "Show confirm password"}
//                 >
//                   {showConfirm ? <FaEyeSlash /> : <FaEye />}
//                 </button>
//               </div>
//               {errors.confirmPassword && (
//                 <div className="log-error">{errors.confirmPassword}</div>
//               )}

//               <div className="log-row-between" style={{ marginTop: 10 }}>
//                 <label className="log-remember">
//                   <input
//                     type="checkbox"
//                     name="smsConsent"
//                     checked={form.smsConsent}
//                     onChange={onChange}
//                   />
//                   <span>
//                     By providing my phone number and checking this box, I consent to
//                     receive SMS messages from PayWeek for account verification (OTP)
//                     and security purposes. Message frequency varies based on activity.
//                     Reply STOP to opt out or HELP for help. Message and data rates may
//                     apply.
//                   </span>
//                 </label>
//               </div>
//               {errors.smsConsent && <div className="log-error">{errors.smsConsent}</div>}

//               <button className="log-submit" type="submit" disabled={submitting}>
//                 {submitting ? "Creating account…" : "Create account"}
//               </button>

//               <button
//                 type="button"
//                 className="log-link-btn"
//                 onClick={() => navigate("/login")}
//               >
//                 Already have an account? Sign in
//               </button>
//             </form>
//           </div>
//         </div>

//         {/* RIGHT SIDE */}
//         <div className="log-right">
//           <div className="log-quote">
//             <div className="log-quote-mark">“</div>
//             <p>
//               Focus on growing your business — PayWeek takes care of your payroll and
//               accounting with speed, precision, and complete security, so you can pay
//               your team effortlessly and on time, every time.
//             </p>
//           </div>

//           <div
//             className="log-dashboard-shell"
//             role="img"
//             aria-label="Dashboard screenshot placeholder"
//           >
//             <img src="/acc-page.png" alt="Dashboard (light)" className="logo--light" />
//             <img src="/dashdark.png" alt="Dashboard (dark)" className="logo--dark" />
//           </div>
//         </div>
//       </div>

//       {showSuccessPopup && (
//         <SuccessPopup
//           title="Registration Successful"
//           message={popupMessage}
//           onClose={handleSuccessClose}
//           buttonLabel="Go to Login"
//         />
//       )}

//       {showErrorPopup && (
//         <ErrorPopup
//           title="Registration Failed"
//           message={popupMessage}
//           onClose={() => setShowErrorPopup(false)}
//           buttonLabel="Close"
//         />
//       )}
//     </React.Fragment>
//   );
// };

// export default Register;



// // src/pages/Register.jsx
// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { FaEye, FaEyeSlash } from "react-icons/fa";
// import api from "../services/api";
// import "./Login.css";
// import AccountHomeButton from "../pages/Auth/account-home-button";

// const Register = () => {
//   const navigate = useNavigate();

//   const [form, setForm] = useState({
//     first_name: "",
//     last_name: "",
//     email: "",
//     phone: "",
//     password: "",
//     confirmPassword: "",
//     smsConsent: false,
//   });
//   const [errors, setErrors] = useState({});
//   const [submitting, setSubmitting] = useState(false);
//   const [showPassword, setShowPassword] = useState(false);
//   const [showConfirm, setShowConfirm] = useState(false);

//   const onChange = (e) => {
//     const { name, type, checked, value } = e.target;
//     setForm((f) => ({ ...f, [name]: type === "checkbox" ? checked : value }));
//   };

//   const validate = () => {
//     const e = {};
//     if (!form.first_name.trim()) e.first_name = "Please enter your first name";
//     if (!form.last_name.trim()) e.last_name = "Please enter your last name";
//     if (!form.email) e.email = "Please enter your email";
//     else if (!/^\S+@\S+\.\S+$/.test(form.email)) e.email = "Invalid email";
//     if (!form.phone.trim()) e.phone = "Please enter your phone number";
//     if (!form.password) e.password = "Please enter your password";
//     else if (form.password.length < 8) e.password = "Password must be at least 8 characters";
//     if (!form.confirmPassword) e.confirmPassword = "Please confirm your password";
//     else if (form.confirmPassword !== form.password) e.confirmPassword = "Passwords must match";
//     if (!form.smsConsent) e.smsConsent = "You must agree to receive SMS for verification";
//     setErrors(e);
//     return Object.keys(e).length === 0;
//   };

//   const onSubmit = async (evt) => {
//     evt.preventDefault();
//     if (!validate()) return;

//     setSubmitting(true);
//     try {
//       await api.post("/register", form);
//       alert("Registration successful!");
//       navigate("/login");
//     } catch {
//       alert("Registration failed.");
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   return (
//     <React.Fragment>
//       <AccountHomeButton />
//     <div className="log-page">
//       {/* LEFT SIDE */}
//       <div className="log-left">
        

//         <div className="log-left-inner">
//           <h1 className="log-title">Registration</h1>
          

//           <form className="log-form" onSubmit={onSubmit} noValidate>
//             {/* First name */}
           
//             <input
//               className={`log-input ${errors.first_name ? "log-input-error" : ""}`}
//               id="first_name"
//               name="first_name"
//               type="text"
//               placeholder="Enter first name"
//               value={form.first_name}
//               onChange={onChange}
//               autoComplete="given-name"
//             />
//             {errors.first_name && <div className="log-error">{errors.first_name}</div>}

//             {/* Last name */}
           
//             <input
//               className={`log-input ${errors.last_name ? "log-input-error" : ""}`}
//               id="last_name"
//               name="last_name"
//               type="text"
//               placeholder="Enter last name"
//               value={form.last_name}
//               onChange={onChange}
//               autoComplete="family-name"
//             />
//             {errors.last_name && <div className="log-error">{errors.last_name}</div>}

//             {/* Email */}
           
//             <input
//               className={`log-input ${errors.email ? "log-input-error" : ""}`}
//               id="email"
//               name="email"
//               type="email"
//               placeholder="Enter Email Address"
//               value={form.email}
//               onChange={onChange}
//               autoComplete="email"
//             />
//             {errors.email && <div className="log-error">{errors.email}</div>}

//             {/* Phone */}
         
//             <input
//               className={`log-input ${errors.phone ? "log-input-error" : ""}`}
//               id="phone"
//               name="phone"
//               type="tel"
//               placeholder="Enter phone number"
//               value={form.phone}
//               onChange={onChange}
//               autoComplete="tel"
//             />
//             {errors.phone && <div className="log-error">{errors.phone}</div>}

//             {/* Password */}
          
//             <div className="log-password-wrap">
//               <input
//                 className={`log-input log-password-input ${errors.password ? "log-input-error" : ""}`}
//                 id="password"
//                 name="password"
//                 type={showPassword ? "text" : "password"}
//                 placeholder="Enter password (min 8 characters)"
//                 value={form.password}
//                 onChange={onChange}
//                 autoComplete="new-password"
//               />
//               <button
//                 type="button"
//                 className="log-eye"
//                 onClick={() => setShowPassword((s) => !s)}
//                 aria-label={showPassword ? "Hide password" : "Show password"}
//                 title={showPassword ? "Hide password" : "Show password"}
//               >
//                 {showPassword ? <FaEyeSlash /> : <FaEye />}
//               </button>
//             </div>
//             {errors.password && <div className="log-error">{errors.password}</div>}

//             {/* Confirm Password */}
           
//             <div className="log-password-wrap">
//               <input
//                 className={`log-input log-password-input ${errors.confirmPassword ? "log-input-error" : ""}`}
//                 id="confirmPassword"
//                 name="confirmPassword"
//                 type={showConfirm ? "text" : "password"}
//                 placeholder="Re-enter password"
//                 value={form.confirmPassword}
//                 onChange={onChange}
//                 autoComplete="new-password"
//               />
//               <button
//                 type="button"
//                 className="log-eye"
//                 onClick={() => setShowConfirm((s) => !s)}
//                 aria-label={showConfirm ? "Hide confirm password" : "Show confirm password"}
//                 title={showConfirm ? "Hide confirm password" : "Show confirm password"}
//               >
//                 {showConfirm ? <FaEyeSlash /> : <FaEye />}
//               </button>
//             </div>
//             {errors.confirmPassword && <div className="log-error">{errors.confirmPassword}</div>}

//             {/* SMS consent */}
//             <div className="log-row-between" style={{ marginTop: 10 }}>
//               <label className="log-remember">
//                 <input
//                   type="checkbox"
//                   name="smsConsent"
//                   checked={form.smsConsent}
//                   onChange={onChange}
//                 />
//                 <span>
//   By providing my phone number and checking this box, I consent to receive SMS messages from PayWeek for account verification (OTP) and security purposes. Message frequency varies based on activity. Reply STOP to opt out or HELP for help. Message and data rates may apply.
// </span>
//               </label>
//             </div>
//             {errors.smsConsent && <div className="log-error">{errors.smsConsent}</div>}

//             {/* Submit */}
//             <button className="log-submit" type="submit" disabled={submitting}>
//               {submitting ? "Creating account…" : "Create account"}
//             </button>

//             {/* Already have account */}
//             <button
//               type="button"
//               className="log-link-btn"
//               onClick={() => navigate("/login")}
//             >
//               Already have an account? Sign in
//             </button>
//           </form>
//         </div>
//       </div>

//       {/* RIGHT SIDE */}
//       <div className="log-right">
//         <div className="log-quote">
//           <div className="log-quote-mark">“</div>
//           <p>
//             Focus on growing your business — PayWeek takes care of your payroll and accounting
//             with speed, precision, and complete security, so you can pay your
//             team effortlessly and on time, every time.
//           </p>
//         </div>
//         <div className="log-dashboard-shell" role="img" aria-label="Dashboard screenshot placeholder">
//           {/* light */}
//           <img src="/acc-page.png" alt="Dashboard (light)" className="logo--light" />
//           {/* dark */}
//           <img src="/dashdark.png" alt="Dashboard (dark)" className="logo--dark" />
//         </div>
//       </div>
//     </div>
//     </React.Fragment>
//   );
// };


// export default Register;



// import React, { useEffect } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import {
//   Container,
//   Row,
//   Col,
//   Card,
//   CardBody,
//   Button,
//   Label,
//   Input,
//   FormFeedback,
//   Form,
// } from "reactstrap";
// import * as Yup from "yup";
// import { useFormik } from "formik";
// import api from "../services/api"; // Import API service
// import AccountHomeButton from "../pages/Auth/account-home-button";

// const Register = () => {
//   const navigate = useNavigate();

//   const validation = useFormik({
//     enableReinitialize: true,
//     initialValues: {
//       first_name: "",
//       last_name: "",
//       email: "",
//       phone: "",
//       password: "",
//       confirmPassword: "",
//       smsConsent: false,
//     },
//     validationSchema: Yup.object({
//       first_name: Yup.string().required("Please Enter Your First Name"),
//       last_name: Yup.string().required("Please Enter Your Last Name"),
//       email: Yup.string().email("Invalid email").required("Please Enter Your Email"),
//       phone: Yup.string().required("Please Enter Your Phone Number"),
//       password: Yup.string().min(8, "Password must be at least 8 characters").required("Please Enter Your Password"),
//       confirmPassword: Yup.string()
//         .oneOf([Yup.ref("password"), null], "Passwords must match")
//         .required("Please Confirm Your Password"),
//     }),
//     onSubmit: async (values) => {
//       if (!values.smsConsent) {
//         alert("You must agree to receive SMS messages for verification purposes.");
//         return;
//       }

//       try {
//         await api.post("/register", values);
//         alert("Registration successful!");
//         validation.resetForm();
//         navigate("/login");
//       } catch (err) {
//         alert("Registration failed.");
//       }
//     },
//   });

//   useEffect(() => {
//     document.body.classList.add("bg-account-pages", "py-4", "py-sm-0");
//     document.getElementById("colorTheme").setAttribute("href", "assets/colors/red.css");

//     return () => {
//       document.body.classList.remove("bg-account-pages", "py-4", "py-sm-0");
//       document.getElementById("colorTheme").setAttribute("href", "assets/colors/cyan.css");
//     };
//   }, []);

//   return (
//     <React.Fragment>
//     {/* Home Button */}
//     <AccountHomeButton />
//       <section className="vh-100">
//         <div className="display-table">
//           <div className="display-table-cell">
//             <Container>
//               <Row className="justify-content-center">
//                 <Col lg="5">
//                   <Card className="account-card">
//                     <CardBody>
//                       <div className="text-center mt-3">
//                         <h3 className="font-weight-bold">
//                           <Link to="/" className="text-dark text-uppercase account-pages-logo">
//                             <i className="mdi"></i> PAYWEEK
//                           </Link>
//                         </h3>
//                         <p className="text-muted">Create a New Account</p>
//                       </div>

//                       <div className="p-4">
//                         <Form onSubmit={validation.handleSubmit}>
//                           <div className="input-register">
                            
//                             <Input
//                               style={{width:"100%"}}
//                               name="first_name"
//                               placeholder="Enter First Name"
//                               type="text"
//                               onChange={validation.handleChange}
//                               onBlur={validation.handleBlur}
//                               value={validation.values.first_name || ""}
//                               invalid={validation.touched.first_name && validation.errors.first_name}
//                             />
//                             <FormFeedback>{validation.errors.first_name}</FormFeedback>
//                           </div>

//                           <div className="input-register">
                            
//                             <Input
//                               style={{width:"100%"}}
//                               name="last_name"
//                               placeholder="Enter Last Name"
//                               type="text"
//                               onChange={validation.handleChange}
//                               onBlur={validation.handleBlur}
//                               value={validation.values.last_name || ""}
//                               invalid={validation.touched.last_name && validation.errors.last_name}
//                             />
//                             <FormFeedback>{validation.errors.last_name}</FormFeedback>
//                           </div>

//                           <div className="input-register">
                            
//                             <Input
//                               name="email"
//                               placeholder="Enter Email"
//                               type="email"
//                               onChange={validation.handleChange}
//                               onBlur={validation.handleBlur}
//                               value={validation.values.email || ""}
//                               invalid={validation.touched.email && validation.errors.email}
//                             />
//                             <FormFeedback>{validation.errors.email}</FormFeedback>
//                           </div>

//                           <div className="input-register">
                            
//                             <Input
//                               style={{width:"100%"}}
//                               name="phone"
//                               placeholder="Enter Phone Number"
//                               type="text"
//                               onChange={validation.handleChange}
//                               onBlur={validation.handleBlur}
//                               value={validation.values.phone || ""}
//                               invalid={validation.touched.phone && validation.errors.phone}
//                             />
//                             <FormFeedback>{validation.errors.phone}</FormFeedback>
//                           </div>

//                           <div className="input-register">
                            
//                             <Input
//                               name="password"
//                               placeholder="Enter Password"
//                               type="password"
//                               onChange={validation.handleChange}
//                               onBlur={validation.handleBlur}
//                               value={validation.values.password || ""}
//                               invalid={validation.touched.password && validation.errors.password}
//                             />
//                             <FormFeedback>{validation.errors.password}</FormFeedback>
//                           </div>

//                           <div className="input-register">
                            
//                             <Input
//                               name="confirmPassword"
//                               placeholder="Confirm Password"
//                               type="password"
//                               onChange={validation.handleChange}
//                               onBlur={validation.handleBlur}
//                               value={validation.values.confirmPassword || ""}
//                               invalid={validation.touched.confirmPassword && validation.errors.confirmPassword}
//                             />
//                             <FormFeedback>{validation.errors.confirmPassword}</FormFeedback>
//                           </div>

//                           {/* SMS Consent Checkbox */}
//                           <div className="custom-control custom-checkbox mt-3">
//                             <Input
//                               type="checkbox"
//                               name="smsConsent"
//                               checked={validation.values.smsConsent}
//                               onChange={validation.handleChange}
//                             />
//                             <Label for="smsConsent"> I agree to receive SMS messages for verification purposes</Label>
//                           </div>

//                           <div className="d-grid mt-3">
//                             <Button type="submit" className="btn btn-primary">
//                               Sign Up
//                             </Button>
//                           </div>

//                           <div className="mt-4 mb-0 text-center">
//                             <p className="mb-0">
//                               Already have an account?{" "}
//                               <Link to="/login" className="text-danger">
//                                 Sign in
//                               </Link>
//                             </p>
//                           </div>
//                         </Form>
//                       </div>
//                     </CardBody>
//                   </Card>
//                 </Col>
//               </Row>
//             </Container>
//           </div>
//         </div>
//       </section>
//     </React.Fragment>
//   );
// };

// export default Register;



// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import api from "../services/api";

// const Register = () => {
//     const [form, setForm] = useState({
//         first_name: "",
//         last_name: "",
//         email: "",
//         phone: "",
//         password: "",
//         confirmPassword: "",
//     });

//     const [isSmsConsentChecked, setIsSmsConsentChecked] = useState(false);
//     const navigate = useNavigate();

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setForm((prevForm) => ({ ...prevForm, [name]: value }));
//     };

//     const handleSmsConsentChange = (e) => {
//         setIsSmsConsentChecked(e.target.checked);
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (form.password !== form.confirmPassword) {
//             alert("Passwords do not match.");
//             return;
//         }

//         if (!isSmsConsentChecked) {
//             alert("You must agree to receive SMS messages for verification purposes.");
//             return;
//         }

//         try {
//             await api.post("/register", form);
//             alert("Registration successful!");

//             // Reset form after success
//             setForm({
//                 first_name: "",
//                 last_name: "",
//                 email: "",
//                 phone: "",
//                 password: "",
//                 confirmPassword: "",
//             });
//             setIsSmsConsentChecked(false);

//             // Redirect to login page
//             navigate("/login");
//         } catch (err) {
//             alert("Registration failed.");
//         }
//     };

//     return (
//         <div className="main">
//             <div className="signup">
//                 <form onSubmit={handleSubmit}>
//                     <label>Sign up</label>
//                     <input name="first_name" placeholder="First Name" value={form.first_name} onChange={handleChange} required />
//                     <input name="last_name" placeholder="Last Name" value={form.last_name} onChange={handleChange} required />
//                     <input name="email" placeholder="Email" type="email" value={form.email} onChange={handleChange} required />
//                     <input name="phone" placeholder="Phone" value={form.phone} onChange={handleChange} required />
//                     <input name="password" placeholder="Password" type="password" value={form.password} onChange={handleChange} required />
//                     <input name="confirmPassword" placeholder="Confirm Password" type="password" value={form.confirmPassword} onChange={handleChange} required />

//                     {/* SMS Consent Checkbox */}
//                     <input type="checkbox" checked={isSmsConsentChecked} onChange={handleSmsConsentChange} />
//                     <label>I agree to receive SMS messages for verification purposes</label>

//                     <button type="submit">Register</button>
//                 </form>
//             </div>
//         </div>
//     );
// };

// export default Register;




// import React, { useState } from "react";
// import api from "../services/api";
// //import "./Styles.css"; // Import your CSS

// const Register = () => {
//     const [form, setForm] = useState({
//         first_name: "",
//         last_name: "",
//         email: "",
//         phone: "",
//         password: "",
//         confirmPassword: "",
//     });

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setForm((prevForm) => ({ ...prevForm, [name]: value }));
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (form.password !== form.confirmPassword) {
//             alert("Passwords do not match.");
//             return;
//         }

//         try {
//             await api.post("/register", form);
//             alert("Registration successful!");
//         } catch (err) {
//             alert("Registration failed.");
//         }
//     };

//     return (
//         <div className="main">
//             <div className="signup">
//                 <form onSubmit={handleSubmit}>
//                     <label for="chk" aria-hidden="true">Sign up</label>
//                     <input name="first_name" placeholder="First Name" onChange={handleChange} required />
//                     <input name="last_name" placeholder="Last Name" onChange={handleChange} required />
//                     <input name="email" placeholder="Email" type="email" onChange={handleChange} required />
//                     <input name="phone" placeholder="Phone" onChange={handleChange} required />
//                     <input name="password" placeholder="Password" type="password" onChange={handleChange} required />
//                     <input name="confirmPassword" placeholder="Confirm Password" type="password" onChange={handleChange} required />
//                     <button type="submit">Register</button>
//                 </form>
//             </div>
//         </div>
//     );
// };

// export default Register;



// import React, { useState } from "react";
// import api from "../services/api";

// const Register = () => {
//     const [form, setForm] = useState({
//         first_name: "",
//         last_name: "",
//         email: "",
//         phone: "",
//         password: "",
//         confirmPassword: "",
//     });

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setForm((prevForm) => ({ ...prevForm, [name]: value }));
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (form.password !== form.confirmPassword) {
//             alert("Passwords do not match.");
//             return;
//         }

//         try {
//             await api.post("/register", form);
//             alert("Registration successful!");
//         } catch (err) {
//             alert("Registration failed.");
//         }
//     };

//     return (
//         <div className="main">
//             <h2>Register</h2>
//             <form onSubmit={handleSubmit}>
//                 <input name="first_name" placeholder="First Name" onChange={handleChange} required />
//                 <input name="last_name" placeholder="Last Name" onChange={handleChange} required />
//                 <input name="email" placeholder="Email" type="email" onChange={handleChange} required />
//                 <input name="phone" placeholder="Phone" onChange={handleChange} required />
//                 <input name="password" placeholder="Password" type="password" onChange={handleChange} required />
//                 <input name="confirmPassword" placeholder="Confirm Password" type="password" onChange={handleChange} required />
//                 <button type="submit">Register</button>
//             </form>
//         </div>
//     );
// };

// export default Register;


